import { useEffect, useState } from 'react';
import {
  Flex,
  Text,
  Box,
  Image,
  FormLabel,
  FormControl,
  Switch,
  Button,
  Center,
  useToast,
  Spinner,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import FormikInput from '../../components/formikinput';
import { useUserContext } from '../../contexts/userContexts';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import useLogin from '../../api/mutations/useLogin';


const Login = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { signIn } = useUserContext();
  const [isLoginDisabled, setIsLoginDisabled] = useState(true);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      rememberMe: false
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid Email").required("Email cannot be empty"),
      password: Yup.string().required("Password cannot be empty"),
      rememberMe: Yup.boolean().required("Select an option for remember me")
    }),
    onSubmit: (values) => handleLogin(values),
  });

  useEffect(() => {
    if (!(formik.values.email && formik.values.password)) {
      setIsLoginDisabled(true)
      return;
    }
    setIsLoginDisabled(false);
  }, [formik.values]);

  const loginMutation = useLogin({
    onSuccess: (res) => {
      if (res?.status === 200) {
        const userRole = res?.data?.user?.role;

        // Only allow owner to login, block employee
        if (userRole === 'employee') {
          toast({
            title: 'Access Denied',
            description: 'Employee users are not allowed to login here',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
          return;
        }

        signIn(res?.data);
        localStorage.setItem("token", res?.data?.token)
        navigate("/sellers-requests");
      }
    },
    onError: (err) => {
      console.log('failed to login');
      console.log(err);
      const response = err.response;
      toast({
        title: 'Failed to log in',
        description: response?.data?.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  });

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  }

  const handleLogin = async (values) => {
    try {
      const data = {
        email: values.email,
        password: values.password,
      }
      loginMutation.mutate(data);
    } catch (e) {
      console.log(e);
      toast({
        title: 'Something went wrong',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
  }

  return (
    <Flex>
      <Box flex={1} bg={"black"}>
        <Center height={"100vh"}>
          <Flex
            alignItems={"center"}
            direction={"column"}
            bg={"grey.400"}
            w={"462px"}
            padding={4}
          >
            <Image src={require("../../assets/logo.svg").default} w={88} h={76} />
            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
            >
              KIDSWEAR
            </Text>
            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
            >
              COLLECTIVE
            </Text>

            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
              marginBlock={8}
            >
              Business Team
            </Text>

            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
              marginBottom={8}
            >
              LOGIN
            </Text>

            <Box mb={4} w={"100%"}>
              <FormikInput
                name="email"
                type="text"
                label="Email Address"
                labelColor={"white"}
                color="#fff"
                placeholder="Enter your email address"
                formik={formik}
              />
            </Box>

            <Box mb={4} w={"100%"}>
              <FormikInput
                name="password"
                label="Password"
                labelColor={"white"}
                placeholder="Enter your password"
                color="#fff"
                isPassword={true}
                formik={formik}
              />
            </Box>

            <FormControl
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              paddingBottom={4}
            >
              <FormLabel
                htmlFor="remember-me"
                mb="0"
                color={"#FFFFFF"}
                fontFamily={"PlusJakartaSansRegular"}
                textTransform={"capitalize"}
                fontSize={"12px"}
              >
                Remember Me
              </FormLabel>
              <Switch id="remember-me" colorScheme={"success"} />
            </FormControl>

            <Button
              alignSelf={"flex-start"}
              marginBottom={8}
              padding={0}
              onClick={handleForgotPassword}
              bg={"transparent"}
              fontSize={12}
              _hover={{
                bg: "transparent",
              }}
            >
              <Text
                color={"#FFFFFF"}
                fontFamily={"PlusJakartaSansRegular"}
                textTransform={"capitalize"}
                fontSize={"12px"}
              >
                Forgot Password
              </Text>
            </Button>

            <Button
              bg={"primary.500"}
              color="#FFFFFF"
              borderRadius={8}
              fontFamily={"PlusJakartaSansMedium"}
              fontSize={"14px"}
              textTransform={"uppercase"}
              paddingInline={16}
              w={"100%"}
              onClick={formik.handleSubmit}
              isDisabled={isLoginDisabled || loginMutation.isLoading}
              _hover={{
                bg: "#273979",
                color: "#737373",
              }}
            >
              {loginMutation.isLoading ? <Spinner /> : "LOGIN"}
            </Button>
          </Flex>
        </Center>
      </Box>
    </Flex>
  );
}

export default Login;